var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card -shadow"},[_c('user-payroll-adjustment-item-table',{attrs:{"id":_vm.id}}),_c('br')],1)}
var staticRenderFns = []

export { render, staticRenderFns }